import { customCreateEnum } from './enumArray'
import { ValueOf } from '@xhgj/xh-jsutils'
const sizeQueryOperatorList = [
  {
    label: '=',
    value: 'EQUALS',
  },
  {
    label: '>',
    value: 'GREATER',
  },
  {
    label: '<',
    value: 'LESS',
  },
] as const

export const sizeQueryOperatorEnum = customCreateEnum(sizeQueryOperatorList)

const sizeConditionList = [
  {
    label: '>',
    value: '1',
  },
  {
    label: '<',
    value: '2',
  },
  {
    label: '=',
    value: '3',
  },
] as const

export const sizeConditionEnum = customCreateEnum(sizeConditionList)

/**
 * 常见的是否选择
 */
const shifouList = [
  {
    label: '是',
    value: '1',
  },
  {
    label: '否',
    value: '0',
  },
] as const

export const shifouEnum = customCreateEnum(shifouList)

const shifouNumList = [
  {
    label: '是',
    value: 1,
  },
  {
    label: '否',
    value: 0,
  },
] as const

export const shifouNumEnum = customCreateEnum(shifouNumList)

export const shifouBoolList = [
  {
    label: '是',
    value: true,
  },
  {
    label: '否',
    value: false,
  },
] as const

const equalValueOperatorList = [
  {
    label: '等于',
    value: 'EQUALS',
  },
  {
    label: '不等于',
    value: 'NO_EQUALS',
  },
] as const

export const equalValueOperatorEnum = customCreateEnum(equalValueOperatorList)

// 供应商性质
export const supplierNatureList = [
  {
    value: '1',
    label: '生产型',
  },
  {
    value: '2',
    label: '服务型',
  },
  {
    value: '3',
    label: '商贸型',
  },
]

export const supplierNatureEnum = customCreateEnum(supplierNatureList)
const saveTypeList = [
  {
    label: '暂存',
    value: 1,
  },
  {
    label: '提交',
    value: 2,
  },
] as const

export type SaveTypeValue = ValueOf<typeof saveTypeList>
export const saveTypeEnum = customCreateEnum(saveTypeList)

export function convertBoolNumstr(val: boolean) {
  return val ? '1' : '0'
}
export function convertFromNumstr(numstr: '1' | '0') {
  return numstr === '1' ? true : false
}

/** 待办事项 category 常量，用于 switch/case 匹配 */
export const TODO_CATEGORY = {
  /** 询价单 */
  INQUIRY: '1',
  /** 物料驳回 */
  MATERIAL_REJECT: '21',
  /** 品牌驳回 */
  BRAND_REJECT: '22',
  /** 需发货 */
  NEED_SHIP: '31',
  /** 需上传凭证 */
  NEED_UPLOAD_VOUCHER: '32',
  /** 凭证驳回 */
  VOUCHER_REJECT: '33',
  /** 开票(待开发票) */
  PENDING_INVOICE: '34',
  /** 发票驳回(电商) */
  INVOICE_REJECT_EC: '35',
  /** 开票(发票录入) */
  INVOICE_ENTRY: '36',
  /** 待接单 */
  PENDING_ORDER: '41',
  /** 取消订货确认 */
  CANCEL_ORDER_CONFIRM: '42',
  /** 发票驳回(自营) */
  INVOICE_REJECT_SELF: '43',
} as const

/**
 * 待办事项 category 枚举
 */
const todoCategoryList = [
  { label: '询价单', value: TODO_CATEGORY.INQUIRY },
  { label: '物料驳回', value: TODO_CATEGORY.MATERIAL_REJECT },
  { label: '品牌驳回', value: TODO_CATEGORY.BRAND_REJECT },
  { label: '需发货', value: TODO_CATEGORY.NEED_SHIP },
  { label: '需上传凭证', value: TODO_CATEGORY.NEED_UPLOAD_VOUCHER },
  { label: '凭证驳回', value: TODO_CATEGORY.VOUCHER_REJECT },
  { label: '开票(待开发票)', value: TODO_CATEGORY.PENDING_INVOICE },
  { label: '发票驳回(电商)', value: TODO_CATEGORY.INVOICE_REJECT_EC },
  { label: '开票(发票录入)', value: TODO_CATEGORY.INVOICE_ENTRY },
  { label: '待接单', value: TODO_CATEGORY.PENDING_ORDER },
  { label: '取消订货确认', value: TODO_CATEGORY.CANCEL_ORDER_CONFIRM },
  { label: '发票驳回(自营)', value: TODO_CATEGORY.INVOICE_REJECT_SELF },
] as const

export const todoCategoryEnum = customCreateEnum(todoCategoryList)
import { customCreateEnum } from './enumArray'
import { ValueOf } from '@xhgj/xh-jsutils'
const sizeQueryOperatorList = [
  {
    label: '=',
    value: 'EQUALS',
  },
  {
    label: '>',
    value: 'GREATER',
  },
  {
    label: '<',
    value: 'LESS',
  },
] as const

export const sizeQueryOperatorEnum = customCreateEnum(sizeQueryOperatorList)

const sizeConditionList = [
  {
    label: '>',
    value: '1',
  },
  {
    label: '<',
    value: '2',
  },
  {
    label: '=',
    value: '3',
  },
] as const

export const sizeConditionEnum = customCreateEnum(sizeConditionList)

/**
 * 常见的是否选择
 */
const shifouList = [
  {
    label: '是',
    value: '1',
  },
  {
    label: '否',
    value: '0',
  },
] as const

export const shifouEnum = customCreateEnum(shifouList)

const shifouNumList = [
  {
    label: '是',
    value: 1,
  },
  {
    label: '否',
    value: 0,
  },
] as const

export const shifouNumEnum = customCreateEnum(shifouNumList)

export const shifouBoolList = [
  {
    label: '是',
    value: true,
  },
  {
    label: '否',
    value: false,
  },
] as const

const equalValueOperatorList = [
  {
    label: '等于',
    value: 'EQUALS',
  },
  {
    label: '不等于',
    value: 'NO_EQUALS',
  },
] as const

export const equalValueOperatorEnum = customCreateEnum(equalValueOperatorList)

// 供应商性质
export const supplierNatureList = [
  {
    value: '1',
    label: '生产型',
  },
  {
    value: '2',
    label: '服务型',
  },
  {
    value: '3',
    label: '商贸型',
  },
]

export const supplierNatureEnum = customCreateEnum(supplierNatureList)
const saveTypeList = [
  {
    label: '暂存',
    value: 1,
  },
  {
    label: '提交',
    value: 2,
  },
] as const

export type SaveTypeValue = ValueOf<typeof saveTypeList>
export const saveTypeEnum = customCreateEnum(saveTypeList)

export function convertBoolNumstr(val: boolean) {
  return val ? '1' : '0'
}
export function convertFromNumstr(numstr: '1' | '0') {
  return numstr === '1' ? true : false
}

/** 待办事项 category 常量，用于 switch/case 匹配 */
export const TODO_CATEGORY = {
  /** 询价单 */
  INQUIRY: '1',
  /** 物料驳回 */
  MATERIAL_REJECT: '21',
  /** 品牌驳回 */
  BRAND_REJECT: '22',
  /** 需发货 */
  NEED_SHIP: '31',
  /** 需上传凭证 */
  NEED_UPLOAD_VOUCHER: '32',
  /** 凭证驳回 */
  VOUCHER_REJECT: '33',
  /** 开票(待开发票) */
  PENDING_INVOICE: '34',
  /** 发票驳回(电商) */
  INVOICE_REJECT_EC: '35',
  /** 开票(发票录入) */
  INVOICE_ENTRY: '36',
  /** 待接单 */
  PENDING_ORDER: '41',
  /** 取消订货确认 */
  CANCEL_ORDER_CONFIRM: '42',
  /** 发票驳回(自营) */
  INVOICE_REJECT_SELF: '43',
} as const

/**
 * 待办事项 category 枚举
 */
const todoCategoryList = [
  { label: '询价单', value: TODO_CATEGORY.INQUIRY },
  { label: '物料驳回', value: TODO_CATEGORY.MATERIAL_REJECT },
  { label: '品牌驳回', value: TODO_CATEGORY.BRAND_REJECT },
  { label: '需发货', value: TODO_CATEGORY.NEED_SHIP },
  { label: '需上传凭证', value: TODO_CATEGORY.NEED_UPLOAD_VOUCHER },
  { label: '凭证驳回', value: TODO_CATEGORY.VOUCHER_REJECT },
  { label: '开票(待开发票)', value: TODO_CATEGORY.PENDING_INVOICE },
  { label: '发票驳回(电商)', value: TODO_CATEGORY.INVOICE_REJECT_EC },
  { label: '开票(发票录入)', value: TODO_CATEGORY.INVOICE_ENTRY },
  { label: '待接单', value: TODO_CATEGORY.PENDING_ORDER },
  { label: '取消订货确认', value: TODO_CATEGORY.CANCEL_ORDER_CONFIRM },
  { label: '发票驳回(自营)', value: TODO_CATEGORY.INVOICE_REJECT_SELF },
] as const

export const todoCategoryEnum = customCreateEnum(todoCategoryList)
